
Vendd.Scripts.load(function () {
    var $wrapper = $('.x-people');

    if ($wrapper.length < 1) return; 

    if(window.location.search.length > 0) {
     $('html,body').animate({ scrollTop: $('.x-people').offset().top - 100 }, 1000);
    }


   $(".js-selected-branch", $wrapper).change(function(){
        var currentPartner = $(this).val();
        var targetUrl =  LhApp.Function.Url.setParameterValueOnUrl(window.location.href, 'partner', currentPartner);
        if (targetUrl) document.location = targetUrl; 
         
     });

});




